import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { UNSTRICT_WS } from "./actionTypes";
import { unstrictWorkstationsSuccess, unstrictWorkstationsError } from "./actions";

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const workstationAPI = getWorkstationsAPI();

function* unstrictWorkstation({ payload: { ws, token, history } }) {

  try {
    const response = yield call(workstationAPI.unstrictPriorityWorkstation, ws, token);
    yield put(unstrictWorkstationsSuccess(response.message));
    history.go()
  } catch (error) {
    yield put(unstrictWorkstationsError(error));
  }
}

export function* watchUnstrictWorkstations() {
  yield takeEvery(UNSTRICT_WS, unstrictWorkstation);
}

function* UnstrictWorkstationsSaga() {
  yield all([fork(watchUnstrictWorkstations)]);
}

export default UnstrictWorkstationsSaga;
